import { c as _c } from "react/compiler-runtime";
import { useGSAP } from '@gsap/react';
import { RefObject } from 'react';
import { gsap } from '@/lib/gsap';
interface Params {
  cardRef: RefObject<HTMLDivElement | null>;
  titleSelector: string;
}
export function useFooterTitleAnimation(t0) {
  const $ = _c(5);
  const {
    cardRef,
    titleSelector
  } = t0;
  let t1;
  if ($[0] !== cardRef || $[1] !== titleSelector) {
    t1 = () => {
      const title = cardRef.current?.querySelector(titleSelector);
      if (!title) {
        return;
      }
      const mm = gsap.matchMedia();
      mm.add({
        isDesktop: "(min-width: 992px)"
      }, context => {
        const {
          isDesktop
        } = context.conditions as gsap.Conditions;
        if (!isDesktop) {
          return;
        }
        const lines = title.querySelectorAll("p, div");
        gsap.fromTo(lines, {
          yPercent: 100,
          y: 0,
          opacity: 0
        }, {
          yPercent: 0,
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          stagger: {
            each: 0.08,
            from: "start"
          },
          scrollTrigger: {
            trigger: title,
            start: "top 90%",
            end: "bottom 60%",
            toggleActions: "play none none reverse"
          }
        });
      });
      return () => mm.revert();
    };
    $[0] = cardRef;
    $[1] = titleSelector;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== cardRef) {
    t2 = {
      scope: cardRef
    };
    $[3] = cardRef;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useGSAP(t1, t2);
}